import React, { useState, useEffect } from 'react';
import Sorter from '../atoms/Sorter';
import Select from '../../components/atoms/Select';
import clsx from 'clsx';
import styles from '../../styles/components/molecules/Sorting.module.scss';

interface SortingProps {
  className?: string;
  onChange: (e: any) => void; //(index: number, e: MouseEvent<HTMLButtonElement>) => void,
  data: {
    value: string;
    label: string;
    order?: string;
    suffix?: string;
  }[];
}

export default function Sorting(props: SortingProps) {
  const { sorting } = styles;
  const { data, onChange, className } = props;
  const [currSort, setCurrSort] = useState({ value: '', order: 'dasc' }) as any;
  const classes = clsx(sorting, className);

  const handleClick = (obj: any) => {
    setCurrSort(obj);
    onChange(obj);
  };

  const handleSelect = (e: any) => {
    const arr = e.target.value.split('-');
    const value = arr[0];
    const order = arr[1] || 'desc';
    const obj = { value, order };
    setCurrSort(obj);
    onChange(obj);
  };

  const options = (data.filter((el) => el.order === 'desc') || [])
    .map((el: any, i: number) => ({
      ...el,
      value: el.value.replace('-asc', '').replace('-desc', ''),
    }))
    .reduce(
      (
        acc: {
          value: string;
          label: string;
          order?: string;
          suffix?: string;
        }[],
        curr: any
      ) => [...acc.filter((el) => el.value !== curr.value), curr],
      []
    )
    .map((el: any, i: number) => {
      const active = currSort ? currSort.value === el.value : false;
      const label = el.label;
      const order = active ? currSort.order : el.order;
      return (
        <li key={i}>
          <Sorter
            active={active}
            data={{ key: el.value, label, order }}
            onClick={(e: string | null) =>
              handleClick({ value: el.value, order: e })
            }
          />
        </li>
      );
    }) as any;

  return (
    <ul className={classes}>
      <li>
        <Select
          initial="Sort by"
          defaultValue={currSort ? `${currSort.value}-${currSort.order}` : ''}
          options={data}
          onChange={handleSelect}
        />
      </li>
      {options}
    </ul>
  );
}
